export default {
  async queryPermissionAsync() {
    return await navigator.permissions.query({name: 'camera'})
    .then(permission => {
      return permission.state
    })
  },
  requestPermissionAsync() {
    return navigator.mediaDevices.getUserMedia({ video: true }).then(stream => {
      stream.getVideoTracks().forEach(track => {
        track.stop()
        stream.removeTrack(track)
      })
    })
  },
  async enumerateDevicesAsync() {
    return await navigator.mediaDevices.enumerateDevices().then(ds => {
      return ds
        .filter(d => !!d.label && d.kind == 'videoinput')
        .sort((a, b) => a.label.localeCompare(b.label))
        .map(d => ({deviceId: d.deviceId, label: d.label}))
    })
  },
}
